
import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
// import { thunk } from "redux-thunk"; // Remove this line

import rootReducer from "./reducer";
import { logout } from "./slices/authSlice";

const appReducer = (state, action) => {
  let newState = state;
  if (action.type === logout.type) {
    newState = undefined;
  }
  return rootReducer(newState, action);
};

const persistConfig = {
  key: "root",
  storage,
  // whitelist: ["cvResults"],
};

const persistedReducer = persistReducer(persistConfig, appReducer);

// Configure the store
// const store = configureStore({
//   reducer: persistedReducer,
//   // devTools: process.env.NODE_ENV !== "production",
//   // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk), // Remove this line
// });
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/REGISTER",
        ],
      },
    }),
});
// Persist the store
const persistor = persistStore(store);

const { dispatch } = store;

// Export the store and persistor
export { store, persistor, dispatch };
// In configureStore.js
export default store;
